


<template>
  <!-- <div> -->
  <!-- <div class="titileDefinition">短信充值</div> -->
  <!-- <div class="line"></div> -->
  <div class="section-right-content-box">
    <div class="box-shadow top-box">
      <div class="global-title">短信充值</div>
      <!-- <div style="padding:20px;">
          <el-alert
            class="alert"
            title="温馨提示：官方短信条数只能在运营者平台栏目下面使用 普通短信营销前往短信充值"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>-->
      <!--切换 -->
      <div class="tab-line">
        <div
          class="tab-item"
          @click="hugItemBtn(1)"
          :class="{ active: topSelect == 1 }"
          :style="{
            color: topSelect == 1 ? changeColor : '',
            'border-top': topSelect == 1 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 1"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          {{ messageOne }}
        </div>
        <div
          class="tab-item"
          @click="hugItemBtn(2)"
          :class="{ active: topSelect == 2 }"
          :style="{
            color: topSelect == 2 ? changeColor : '',
            'border-top': topSelect == 2 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 2"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          {{ messageTwo }}
        </div>
        <div
          class="tab-item"
          @click="hugItemBtn(3)"
          :class="{ active: topSelect == 3 }"
          :style="{
            color: topSelect == 3 ? changeColor : '',
            'border-top': topSelect == 3 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 3"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          {{ messageThree }}
        </div>
        <div
          class="tab-item"
          @click="hugItemBtn(4)"
          :class="{ active: topSelect == 4 }"
          :style="{
            color: topSelect == 4 ? changeColor : '',
            'border-top': topSelect == 4 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 4"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          {{ messageFour }}
        </div>
      </div>
      <!-- 短信充值模块 -->
      <div class="recharge-box" v-show="topSelect === 1" id="insertPosition">
        <!-- <div class="alert_box">
          <div class="alert">
            <span class="icon_i">i</span
            >页面装修是为商家提供的针对店铺会员中心样式调整的个性化功能，通过此功能商家可以灵活的调整店铺会员中心页面布局和展示样式提高页面灵活性及扩展性，客户体验更加友好。
          </div>
        </div> -->

        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">自定义充值</span>&nbsp;
          <span class="tips">
            <el-popover
              placement="right-start"
              width="250"
              trigger="hover"
              content
            >
              <div class="tips">
                <p :style="{ color: changeColor }">充值条数单价</p>
                <p>
                  100条~4999条
                  <span>(6.80分/条)</span>
                </p>
                <p>
                  5000条~99999条
                  <span>(6.50分/条)</span>
                </p>
                <p>
                  100000条~499999条
                  <span>(5.80分/条)</span>
                </p>
                <p>
                  500000条~999999条
                  <span>(5.20分/条)</span>
                </p>
                <!-- <p>
                  50000条~99999条
                  <span>(5.50分/条)</span>
                </p>
                <p>
                  100000条~199999条
                  <span>(5.20分/条)</span>
                </p>
                <p>
                  200000条~499999条
                  <span>(5.10分/条)</span>
                </p>
                <p>
                  500000条~999999条
                  <span>(5.00分/条)</span>
                </p> -->
                <p>
                  1000000条以上
                  <span>(5.00分/条)</span>
                </p>
              </div>
              <span slot="reference" class="question_iconText">
                充值规则
                <span class="question_icon">?</span>
              </span>
            </el-popover>
          </span>
        </div>
        <!-- 表单部分 -->
        <div class="form-box">
          <div class="item" style="margin-right: 30px">
            <span class="item-name">充值短信条数：</span>
            <el-input
              style="
                display: inline-block;
                vertical-align: middle;
                width: 140px;
                margin-right: 10px;
              "
              size="medium"
              v-model="rechargeMessageNum"
              @keyup.native="preventinput($event)"
              onkeypress="return event.keyCode>=48 && event.keyCode<=57"
              @input="rechargeMessageNumChange"
              @change="rechargeMessageRemind"
              placeholder="请输入..."
            ></el-input>
            <span class="item-name">条</span>
          </div>
          <div class="item">
            <span class="item-name">充值金额：</span>
            <!-- <span :style="{'color': changeColor}">{{rechargeMoney}}</span> -->
            <el-input
              style="
                display: inline-block;
                vertical-align: middle;
                width: 140px;
                margin-right: 10px;
              "
              size="medium"
              @keyup.native="preventinput($event)"
              v-model="rechargeMoney"
              @input="rechargeMoneyChange"
              @change="rechargeMoneyRemind"
              placeholder="请输入..."
            ></el-input>
            <span class="item-name">元</span>
          </div>
          <el-button v-zoom='{from:pageName,name:"支付宝充值"}' @click="ImmediateRecharge" class="itemBottom">
            支付宝充值
          </el-button>
          <!-- <el-button
            type="primary"
            size="small"
            :style="{'background': '#fff','color': changeColor,'border': '1px solid' + changeColor}"
            @click="toScanCode"
            style="display: inline-block; vertical-align: middle;float: right;margin-right: 20px;"
            >扫码转账充值</el-button>-->
        </div>
        <!-- 充值格子部分 -->
        <div class="containCharge">
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">充值包充值</span>
          </div>
          <div
            class="block-box"
            v-for="(item, index) in blockData"
            :key="index"
            :class="[
              item.rechargeType == 1 ? 'block-vip' : '',
              item.rechargeType == 2 ? 'block-vip' : '',
              item.isCountDown != 0 && item.rechargeType == 3
                ? 'block-tuijian'
                : '',
              item.isCountDown == 0 && item.rechargeType == 3
                ? 'block-tuijian1'
                : '',
              item.rechargeType == 4 ? 'block-tehui' : '',
            ]"
          >
            <div v-if="item.rechargeType == 1 || item.rechargeType == 2">
              <img
                src="@/assets/images/backstage/recharge_discounts.png"
                style="position: absolute; margin: -39px 0 0 200px"
              />
            </div>
            <div v-if="item.rechargeType == 4">
              <img
                src="@/assets/images/backstage/recharge_vip.png"
                style="position: absolute; margin: -39px 0 0 202px"
              />
            </div>

            <changetime
              v-if="item.isCountDown == 1"
              :ids="item.showTimeEnd"
              :ids1="item.showTimeStart"
            ></changetime>
            <div v-if="item.isCountDown == 0 && item.rechargeType == 3">
              <img
                src="@/assets/images/backstage/recharge_recommend.png"
                style="position: absolute; margin: -39px 0 0 200px"
              />
            </div>
            <div class="imgRelative">
              <!-- <img v-if="item.rechargeType==2" src="@/assets/images/vip1.png" alt="">
             <img v-if="item.rechargeType==1" src="@/assets/images/tehui.png" alt="">
                <img v-if="item.rechargeType==3" src="@/assets/images/tui.png" alt="">-->
            </div>
            <div class="buttonRelative">
              <el-button
                @click="rechargeTap(index)"
                v-if="item.rechargeType == 1 || item.rechargeType == 2"
                round
                type="primary"
                class="buttonStyle"
                v-zoom='{from:pageName,name:"立即充值"}'
                >立即充值</el-button
              >
              <el-button
                @click="rechargeTap(index)"
                v-if="item.rechargeType == 4"
                round
                type="danger"
                style="border: 0px solid"
                class="buttonStyleOne"
                v-zoom='{from:pageName,name:"立即充值"}'
                >立即充值</el-button
              >
              <el-button
                @click="rechargeTap(index)"
                v-if="item.isCountDown == 0 && item.rechargeType == 3"
                round
                type="primary"
                class="buttonStyleTwo"
                v-zoom='{from:pageName,name:"立即充值"}'
                >立即充值</el-button
              >
              <el-button
                @click="rechargeTap(index)"
                v-if="item.isCountDown != 0 && item.rechargeType == 3"
                round
                type="primary"
                class="buttonStyleThere"
                v-zoom='{from:pageName,name:"立即充值"}'
                >立即充值</el-button
              >
              <!-- <el-button
                @click="rechargeTap(index)"
                v-if="item.isCountDown == 0 && item.rechargeType == 4"
                round
                type="primary"
                class="buttonStyleTwo"
                >立即充值</el-button
              >
              <el-button
                @click="rechargeTap(index)"
                v-if="item.isCountDown != 0 && item.rechargeType == 4"
                round
                type="primary"
                class="buttonStyleThere"
                >立即充值</el-button
              > -->
            </div>
            <div
              class="block"
              :class="[
                item.rechargeType == 1 ? 'block-1' : '',
                item.rechargeType == 2 ? 'block-2' : '',
                item.rechargeType == 3 ? 'block-3' : '',
                item.rechargeType == 4 ? 'block-2' : '',
              ]"
            >
              <div class="line-one">
                <span
                  class="big-text"
                  :class="[
                    item.rechargeType == 1 ? 'big-text1' : '',
                    item.rechargeType == 2 ? 'big-text1' : '',
                    item.rechargeType == 3 ? 'small-text3' : '',
                    item.rechargeType == 4 ? 'big-text2' : '',
                  ]"
                  >{{ item.amount | numFormat }}</span
                >
                <span
                  class="small-text"
                  :class="[
                    item.rechargeType == 1 ? 'small-text1' : '',
                    item.rechargeType == 3 ? 'small-text1' : '',
                    item.rechargeType == 2 ? 'small-text1' : '',
                    item.rechargeType == 4 ? 'small-text2' : '',
                  ]"
                  >条短信</span
                >
              </div>
              <div
                class="lineHeight"
                :class="[
                  item.isCountDown != 0 && item.rechargeType == 3
                    ? 'lineHeight-1'
                    : '',
                  item.isCountDown == 0 && item.rechargeType == 3
                    ? 'lineHeight-3'
                    : '',
                  item.rechargeType == 2 ? 'lineHeight-2' : '',
                ]"
              ></div>
              <div class="line-two">
                <span
                  class="line-two1"
                  :class="[
                    item.rechargeType == 1 ? 'line-two1-1' : '',
                    item.rechargeType == 3 ? 'line-two1-1' : '',
                    item.rechargeType == 2 ? 'line-two1-1' : '',
                    item.rechargeType == 4 ? 'line-two1-2' : '',
                  ]"
                  >优惠价：</span
                >
                <span
                  :class="[
                    item.rechargeType == 1 ? 'line-two-0' : '',
                    item.rechargeType == 3 ? 'line-two-1' : '',
                    item.rechargeType == 2 ? 'line-two-0' : '',
                    item.rechargeType == 4 ? 'line-two-2' : '',
                  ]"
                  >¥{{ item.money | numFormat }}</span
                >
              </div>
              <div class="line-three" style="float: right">
                <div class="float-left">
                  <span
                    class="danPrice"
                    :class="[
                      item.rechargeType == 1 ? 'danPrice-1' : '',
                      item.rechargeType == 3 ? 'danPrice-1' : '',
                      item.rechargeType == 2 ? 'danPrice-1' : '',
                      item.rechargeType == 4 ? 'danPrice-2' : '',
                    ]"
                    >&nbsp;单价：</span
                  >
                  <span
                    class="danPrice1"
                    :class="[
                      item.rechargeType == 1 ? 'danPrice1-0' : '',
                      item.rechargeType == 3 ? 'danPrice1-1' : '',
                      item.rechargeType == 2 ? 'danPrice1-1' : '',
                      item.rechargeType == 4 ? 'danPrice1-2' : '',
                    ]"
                    >¥{{ item.price }}</span
                  >
                  <span
                    class="danPrice"
                    :class="[
                      item.rechargeType == 1 ? 'danPrice-1' : '',
                      item.rechargeType == 3 ? 'danPrice-1' : '',
                      item.rechargeType == 2 ? 'danPrice-1' : '',
                      item.rechargeType == 4 ? 'danPrice-2' : '',
                    ]"
                    >分/条</span
                  >
                </div>
                <div style="clear: both"></div>
              </div>
              <div class="originalPrice" v-if="item.originalMoney != 0">
                原价：{{ item.originalMoney }}
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
        <!-- 页脚部分 -->
        <div style="margin-top: 10px">
          <div class="footerClass">
            <div>
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 3px 4px 0 3px;
                "
              />云短信支持开发票，跨年度发票不支持，如需开票请及时申请。
            </div>
            <div style="margin-left: 20px">
              充值套餐后，短信未到账，充值套餐过程如有问题请联系在线客服
              <span class="qqSay" @click="qqTan" style="font-size: 12px"
                >QQ交谈</span
              >客服手机：18925068928。
            </div>
            <div style="margin-left: 20px">
              短信永久有效，如软件过期，续订成功后之前剩余的短信还可以继续使用。
              <span
                class="orderAndUse"
                @click="software"
                v-zoom='{from:pageName,name:"订购使用"}'
                style="font-size: 12px"
                >订购使用</span
              >
            </div>
          </div>
          <!-- <span>云短信支持开发票，跨年度发票不支持，如需开票请及时申请。</span>
          <span>充值套餐后，短信未到账，充值套餐过程如有问题请联系在线客服<a href='https://wpa.qq.com/msgrd?v=3&uin=800152084&site=qq&menu=yes' target='_blank' style='display:inline-block;line-height:25px;'>
            <img :src='qq_image'>
          </a> 客服手机：18925068928</span>  -->
        </div>
        <!-- 立即充值弹窗 -->
        <el-dialog
          title="套餐充值"
          :visible.sync="dialogVisible"
          width="635px"
          :before-close="handleClose1"
          class="ImmediateRecharge"
          height="467px"
        >
          <div class="ImmediateRecharge-dialog1">
            &nbsp;
            <span class="fontBold">充值套餐：</span
            ><span>{{ this.rechargeData.priceProject }}</span>
            <el-table
              :data="checkedPackage"
              :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
              tooltip-effect="light"
              style="
                display: inline-block;
                border: 1px solid #eee;
                vertical-align: top;
                width: 87%;
                position: relative;
              "
            >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
              <el-table-column
                prop="amount"
                label="短信条数(条)"
              ></el-table-column>
              <el-table-column
                prop="price"
                label="单价(分/条)"
              ></el-table-column>
              <el-table-column
                v-if="checkedPackage.originalMoney != 0"
                prop="originalMoney"
                label="售价(元)"
              ></el-table-column>
              <el-table-column label="优惠价(元)">
                <template>
                  <span style="color: red">{{
                    checkedPackage[0].money
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 30px">
              &nbsp;
              <span class="fontBold">套餐数量：</span>
              <el-input-number
                v-model="rechargeCount"
                @change="handleChange"
                style="width: 100px"
                size="small"
                :min="1"
                :max="10"
                label="描述文字"
              ></el-input-number>
            </div>
            <div style="margin-top: 30px">
              &nbsp;
              <span class="fontBold">充值方式：</span>
              <div class="payType">
                <el-radio-group
                  v-model="rechargeManner"
                 
                >
                  <el-radio :label="0" v-if="isShowAliPay">支付宝支付</el-radio>
                  <el-radio :label="3" v-if="isShowPrePay">网银支付</el-radio>
                  <!-- <el-radio :label="1">微信支付</el-radio> -->
                  <!-- <el-radio :label="2">京东货款</el-radio> -->
                </el-radio-group>
                <!-- <el-radio-group
                  v-model="rechargeManner"
                  v-if="thisPayType != 0"
                >
                  <el-radio :label="0" v-if="thisPayType == 1"
                    >支付宝支付</el-radio
                  > -->
                  <!-- <el-radio :label="1">微信支付</el-radio> -->
                  <!-- <el-radio :label="2" v-if="thisPayType == 2"
                    >京东货款</el-radio
                  >
                </el-radio-group> -->
              </div>
            </div>
            <div class="orderBottom" style="margin-top: 20px; margin-left: 2px">
              <!-- <div class="redPacketReduction">
                <span class="duosaho"
                  >红包减免：￥{{ checkedPackage[0].totalMoney }}</span
                >
              </div> -->
              <span
                class="sumPayable"
                :style="{ 'background-color': changeColor }"
                >实付金额：￥{{ checkedPackage[0].totalMoney }}</span
              >
            </div>
            <div class="goPayButton">
              <!-- <el-button
                @click="goGoPay"
                type="danger"
                style="margin-bottom:30px;margin-top:20px;margin-right:12px;width:106px;height:40px;font-size:16px;"
                >去支付</el-button>-->
              <el-button
                plain
                @click="
                  dialogVisible = false;
                  weixinDialogVisible1 = false;
                "
                style="width: 98px; height: 32px; font-size: 14px"
                >取消</el-button
              >
              <el-button
                @click="goGoPay(checkedPackage[0].money)"
                type="primary"
                v-loading="payLoading"
                style="width: 98px; height: 32px; font-size: 14px"
                >去支付</el-button
              >
            </div>
          </div>
        </el-dialog>
        <!-- 微信二维码弹窗 -->
        <el-dialog
          :visible.sync="weixinDialogVisible"
          title="微信支付"
          width="250px"
          center
          :modal="false"
          style="margin-left: 634px; bottom: -300px"
        >
          <div class="weixinDialog">
            <h2 class="textCenter" style="margin-top: 0px">快捷支付</h2>
            <h3 class="textCenter" style="margin-bottom: 2px">
              打开微信 扫一扫支付
            </h3>
            <div class="weixerweima">
              <!-- <img :src="wxData.image" alt> -->
            </div>
            <div style="display: flex; justify-content: center">
              <div>
                <!-- <img  src="@/assets/images/wechatpay.png"  alt style="vertical-align:middle"> -->
                <span style="font-weight: bold; font-size: 18px">微信支付</span>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
      <!--充值记录模块 -->
      <div class="record-box" v-show="topSelect === 2">
        <el-form ref="recordFormSearch" :inline="true" :model="recordParams" label-width="80px">
          <el-form-item label="充值类型">
            <el-select v-model="recordParams.type">
              <el-option
                v-for="(item, index) in remartListTwo"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值时间:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="recordParams.startTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                :picker-options="pickerOptionsStart()"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px;font-size:12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="recordParams.endTime"
                :picker-options="pickerOptionsEnd()"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px;font-size:12px"
                class="time2"
                @change="onChangeTime"
                :clearable="false"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="search"  @click="queryPayRecord">
            <i
              class="el-icon-search"
              style="display:inline-block;width:14px;height:12px;"
            ></i>  
              查询
            </el-button>
            <el-button class="b2" @click="recordPopupReset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="recordData"
          style="width: 100%; opacity: 1"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
        >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
          <el-table-column width="30"></el-table-column>
          <el-table-column
            prop="crtime"
            label="充值时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="paySmsCount"
            label="充值短信条数"
          ></el-table-column>
          <el-table-column
            prop="money"
            label="实付金额"

          ></el-table-column>
          <!-- <el-table-column label="付款方式" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.type | statusStr1 }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="充值类型" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.typeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充值状态" width="180">
            <template slot-scope="scope">
              <span v-if="(scope.row.status = 1)">
                <div class="auditSuccessful"></div>
                <div class="auditSuccessful_ok"></div>
                <div
                  style="float: left; margin-left: 20px"
                  class="auditSuccessful_title"
                >
                  已支付
                </div>
              </span>
              <span v-else-if="(scope.row.status = 0)">
                <div class="underReviewCenter">-</div>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" label="交易流水号"></el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align: right; margin-top: 20px; margin-right: 120px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="recordParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordTotal"
          :current-page="recordParams.current"
        >
        </el-pagination>
      </div>
      <!-- 短信充值记录官方模块 -->
      <div class="record-box" v-show="topSelect === 3">
        <el-table
          :data="officalTable"
          style="width: 100%; opacity: 1"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
        >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
          <el-table-column width="30"></el-table-column>
          <el-table-column
            prop="crtime"
            label="充值时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="paySmsCount"
            label="充值短信条数"
          ></el-table-column>
          <el-table-column
            prop="money"
            label="实付金额"
          ></el-table-column>
          <!-- <el-table-column label="付款方式" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.type | statusStr1 }}</span>
              </template>
            </el-table-column> -->
          <el-table-column label="充值类型">
            <template slot-scope="scope">
              <span>{{ scope.row.typeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充值状态" width="180">
            <template slot-scope="scope">
              <span v-if="(scope.row.status = 1)">
                <div class="auditSuccessful"></div>
                <div class="auditSuccessful_ok"></div>
                <div
                  style="float: left; margin-left: 20px"
                  class="auditSuccessful_title"
                >
                  已支付
                </div>
              </span>
              <span v-else-if="(scope.row.status = 0)">
                <div class="underReviewCenter">-</div>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" label="交易流水号"></el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align: right; margin-top: 20px"
          @size-change="handleSizeChangeOne"
          @current-change="handleCurrentChangeOne"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="officalParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordTotal"
          :current-page="officalParams.current"
        ></el-pagination>
      </div>
      <!-- 短信转移 -->
      <div class="exchange-box" v-show="topSelect === 4">
        <div class="header-tips-box">
          <!-- <img src="../../assets/images/tishi.png" class="tips-icon" /> -->
          <div class="tips-content">
            <div class="alert_box">
              <div class="alert">
                <img
                  src="@/assets/images/new_icon_waring_yellow.png"
                  style="
                    display: inline-block;
                    float: left;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 3px 4px 0 0px;
                  "
                />
                短信转移后将无法撤回，请务必确保店铺账号（如jd_xxxxx）填写正确，建议先测试转移1条，以免转移错误，造成不必要的损失。
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="item">
          <span>转出店铺：</span>
          <span>{{ shopInfo.shopTitle }}</span>
          <div class="num-box" :style="{ color: changeColor }">
            <span
              class="span"
              :style="{ 'background-color': '#ddd' }"
            ></span>
            <span style="color:#333">短信余额：</span>
            <span>{{ shopPeple }}</span>
            <span style="color:#333">条</span>
          </div>
        </div>
        <div class="item" style="color: #333333">
          <span>转移短信：</span>
          <el-input
            size="small"
            placeholder="请输入短信条数"
            v-model="transferParams.count"
            style="
              display: inline-block;
              vertical-align: middle;
              width: 280px;
              margin-right: 8px;
            "
            type="number"
            @change="surplusMessageChange"
          ></el-input>
          <span class="item_span" style="margin-right: 116px">条</span>

          <span>转入店铺：</span>

          <el-input
            placeholder="请输入店铺账号"
            size="small"
            v-model="transferParams.shopName"
            style="
              width: 280px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 8px;
            "
          ></el-input>

          <el-button
            type="primary"
            size="small"
            v-zoom='{from:"后台管理-短信充值-短信转移",name:"短信转移"}'
            @click="transferSmsTap"
            style="font-size: 14px; margin-bottom: 10px"
            >短信转移</el-button
          >

          <div class="alert_box" v-if="!shopInfo.mobile">
            <div class="alert">
              <img
                src="@/assets/images/new_icon_waring.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 4px 4px 0 0px;
                "
              />你还未绑定手机号，无法进行发起申请 点击
              <span
                slot="reference"
                style="
                  color: rgba(254, 77, 69, 1);
                  margin-right: 8px;
                  cursor: pointer;
                "
                @click="bordPhone"
                >绑定手机号</span
              >
            </div>
          </div>
        </div>

        <!-- <div v-if="!shopInfo.mobile" class="bind-tips">
          <span class="mark">!</span>
          <span>您还未绑定手机号</span>
          <el-button type="text" style="margin-left: 15px"
            >立即绑定手机号</el-button
          >
        </div> -->

        <!-- 表格模块 -->
        <el-table :data="smsTableNum" style="width: 100%">
          <el-table-column
            prop="moveoutShop"
            label="转出店铺"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="转入时间"
          ></el-table-column>
          <el-table-column
            prop="moveinShop"
            label="转入店铺"
          ></el-table-column>
          <el-table-column
            prop="moveSmsCount"
            label="转赠数量"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 提示弹窗 -->
      <el-dialog
        title="提示"
        width="400px"
        :visible.sync="chargeInfoVisible"
        center
        class="chargeInfo"
        top="35vh"
      >
        <div class="tips" style="text-align: center">请在新窗口完成充值</div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="chargeSuccess"
            type="primary"
            size="medium"
            style="margin-right: 10px"
            >已充值成功</el-button
          >
          <a
            style="display: inline-block"
            href="https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=%E7%BE%8E%E6%BB%B4%E7%94%9F%E6%B4%BB&site=cntaobao"
            target="_blank"
          >
            <el-button class="wrong" type="primary" plain size="medium"
              >遇到问题</el-button
            >
          </a>
        </span>
      </el-dialog>
      <!-- 短信转移弹窗 -->
      <el-dialog
        title="身份验证"
        :visible.sync="exchangeMsg"
        width="35%"
        center
      >
        <template slot="title">
          <span>身份验证</span>
        </template>
        <div class="exchange-msg-wrapper">
          <div class="tips-head">
            <img src="../../assets/images/tishi.png" class="tips-icon" />
            <span>为了保护您的财产安全，短信转移需要手机验证</span>
          </div>
          <div class="checked-box">
            <div class="item">
              <span>手机号：</span>
              <!-- <span>{{ shopInfo.mobile }}</span> -->
              <span>{{ exchangePhone }}</span>
            </div>
            <div class="item">
              <span>验证码：</span>
              <el-input
                v-model="transferVerifyIdentityParams.inputCode"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 95px;
                "
                size="small"
              ></el-input>
              <el-button
                type="text"
                style="margin-left: 10px"
                @click="getCaptcha"
                >{{ countDown }}{{ getVerCodeTitle }}</el-button
              >
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmExchange">确定</el-button>
          <el-button @click="exchangeMsg = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  alipayPay,
  queryPriceConfig,
  queryPayRecord,
  getWeixinQRCodeWithMessage,
  officialRecords,
  smsPage,
  verifyIdentityShore,
  trans,
  smsVerifyCode,
  closeStatueVerify,
  wenXinPay,
  prePay
} from "@/api/backstage/smsPay";
// import ChangeTime from "./changetime";
import { querySellerSetting } from "@/api/backstage/a_setting";
import { getSellerInfo, getShopInfo } from "@/api/sellerController"; //获取当前客户信息
import { mapState, mapMutations } from "vuex";
import changetime from "./changetime.vue";
export default {
  components: { changetime },
  name: "smsrecharge",
  filters: {
    statusStr(status) {
      return { 0: "未支付", 1: "已支付", null: "null" }[status];
    },
    statusStr1(status) {
      return {
        1: "赠送",
        2: "京东后台订购",
        3: "支付宝接口充值",
        5: "账号充值转移",
        6: "银行转账",
        7: "支付宝转账",
        8: "其他转账",
        10: "微信支付",
        11: "微信扫码支付",
        12: "短信转移",
        null: "null",
      }[status];
    },
    toWan(val) {
      if (val >= 10000) {
        if (val % 10000 == 0) {
          return val / 10000 + "w";
        } else {
          return (val / 10000).toFixed(0) + "w";
        }
      } else {
        return val;
      }
    },
    numFormat(num) {
      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    },
    rechargeTypeStr(rechargeType) {
      return { 1: "首充特惠", 2: "特惠包", 3: "普通" }[rechargeType];
    },
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
    // ChangeTime,
  },
  data() {
    return {
      pageName:"后台管理-短信充值",
      rechargeManner: -1,
      stateofpayment: "FAIL", //微信二维码支付状态
      wxData: {}, //微信支付接口返回的数据
      exchangePhone: "", //身份验证弹框号码
      submitting: !1, // 防止重复发送短信
      countDown: null, // 60s短信发送时间
      getVerCodeTitle: "获取验证码", // 短信验证码中文
      transferRecordList: [], //短信转移表格
      transferParams: {
        shopName: "", // 店铺名或旺旺号
        count: "", // 转移短信数量
      },

      shopInfo: {}, // 店铺信息
      scanCodeDialogVisible: false,
      blockData: [], //充值包选择数据
      topSelect: 1, //头部切换栏
      messageOne: "短信充值",
      messageTwo: "充值记录",
      day: "",
      hr: "",
      min: "",
      sec: "",
      isCountDownOpen: 2,
      messageThree: "充值记录（官方）",
      messageFour: "短信转移",
      //qq_image:require('@/assets/images/qq_talk.gif'),
      dialogVisible: false, //立即充值弹窗
      exchangeMsg: false, //短信转移弹窗
      rechargeMessageNum: "", //充值短信条数
      rechargeMoney: '', //充值金额
      alipayData: "",
      message: "",
      blockDatamoney: "", //点击充值包充值里面的金额
      chargeInfoVisible: false, //充值后弹窗
      recordParams: {
        //充值记录表格
        type:'',
        startTime:'',
        endTime:'',
        current: 1,
        size: 10,
      },
      thisPayType: "",
      ids: "",
      ids1: "",
      officalParams: {
        //充值记录(官方)表格
        current: 1,
        size: 10,
      },
      smsParams: {
        //短信转移表格
        current: 1,
        size: 10,
      },
      recordTotal: 0,
      recordData: [],
      weixinDialogVisible1: false,
      checkedPackage: [
        //立即充值弹窗数据
        {
          amount: 0,
          price: 0,
          originalMoney: "",
          concessionalRate: "",
          totalMoney: 0,
          money: 0,
          payType: "",
        },
      ],
      remartListTwo:[
        {label:'--全部--',value:''},
        {label:'赠送',value:'1'},
        {label:'京东后台订购',value:'2'},
        {label:'支付宝接口充值',value:'3'},
        {label:'账号充值转移',value:'5'},
        {label:'银行转账',value:'6'},
        {label:'支付宝转账',value:'7'},
        {label:'银联支付',value:'18'},
        {label:'其他转账',value:'8'},
        {label:'微信支付',value:'10'},
        {label:'微信扫码支付',value:'11'},
        {label:'短信转移',value:'12'},
        {label:'充值转移（店铺内，官方转普通短信）',value:'13'},
        {label:'充值转移（店铺内，普通转官方）',value:'14'},
        {label:' 补短信',value:'15'},
        {label:'精准营销短信退回（官方频控等原因未成功发送）',value:'16'},
        {label:'抽奖礼品',value:'17'},
      ],
      first:true,
      rechargeCount: 1, //套餐数量
      rechargeData: {}, //弹窗充值包回显
      showcode: false, //二维码显示
      weixinDialogVisible: false, //微信支付弹窗窗口
      wxData: {}, //微信支付接口返回的数据
      price: 9999,
      payTypeCheck: 1, //支付方式动态
      officalTable: [],
      // thistime: "2020-11-28 15:39:30",
      smsTableNum: [],
      showTimeEndShuJu: [], //需要限时折扣的数据
      shopPeple: "", //短信转移获取当前店铺的总条数
      /***
       * 转移验证身份参数
       * */
      transferVerifyIdentityParams: {
        shopName: "",
        moveSmsCount: "",
        inputCode: "",
      },
      payLoading: false,
      isShowAliPay: false, // 是否显示支付宝支付
      isShowPrePay: false, // 是否显示网银支付
    };
  },
  mounted: function () {
    this.getShopInfo();
    this.getSoftwareInfo();
    this.getQueryPriceConfig();
    // this.queryPayRecord();
    this.officialRecords();
    this.smsPage();
    this.countdown();
    // this.recordParams.endTime = this.getDateStr(0) + " 23:59:59"
  },
  created() {},
  methods: {
    onChangeTime(val){
      if (this.first) {
        // if (this.recordParams.endTime=="") {
          this.recordParams.endTime = val.split(" ")[0] + " 23:59:59"
          this.first = false
        // }
        
      }
      // console.log(val);
      // console.log(this.recordParams.endTime);
    },
    pickerOptionsStart() {
      return {
          disabledDate: (time) => {
              if (this.recordParams.endTime) {
                var flag = false;
                // if (this.limit30 || this.time == '6') {
                  // flag =  time.getTime() > new Date(this.recordParams.startTime).getTime() ||  time.getTime() < this.minTime;
                // }else {
                  flag =  time.getTime() > new Date(this.recordParams.endTime).getTime();
                // }
                return flag;
              }
          },
      }
    },
    pickerOptionsEnd() {
      return {
          disabledDate: (time) => {
              var flag = false;
              // if (this.time == '4' || this.time == '5') {
              //   if (time > Date.now() - 8.64e7) {
              //     flag = true
              //   }
              // }
              // if (this.time == '6') {
              //   if (time > Date.now()) {
              //     flag = true;
              //   }
              // }

              if (this.recordParams.startTime) {
                  return time.getTime() < new Date(this.recordParams.startTime).getTime() || flag;
              }
          },
      }
    },
    //绑定手机号
    bordPhone() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/account/account",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 充值记录查询
    // recordPopupQuery(){
    //   this.queryPayRecord()
    // },
    // 充值记录条件重置
    recordPopupReset(){
      this.recordParams.startTime = "";
      this.recordParams.endTime = "";
      this.recordParams.type = "";
      this.first = true;
      this.queryPayRecord()
    },
    clearTimeSendTime() {
      this.first = true;
      this.recordParams.startTime = "";
      this.recordParams.endTime = "";
    },
    confirmExchange() {
      if (this.transferVerifyIdentityParams.inputCode.length == 0) {
        this.$message.info("请输入验证码");
        return;
      }
      if (this.submitting == !1) {
        this.$message.info("请先获取验证码");
        return;
      }
      this.$confirm(
        `确定转${this.transferParams.count}条短信到【${this.transferParams.shopName}】吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass: "iconfont iconicon-jinggao1",
        }
      )
        .then(() => {
          this.transferSMS();
        })
        .catch(() => {
          // this.$message.info("已取消转移");
        });
    },
    /** *
     * 获取短信验证码
     * */
    getCaptcha: function () {
      if (!this.submitting) {
        this.submitting = !0;
        smsVerifyCode({
          mobile: this.exchangePhone,
        })
          .then((response) => {
            this.startCountDown();
          })
          .catch(function () {});
      }
    },
    /** *
     * 短信验证码重发时间
     * */
    startCountDown: function () {
      (this.countDown = 60), (this.getVerCodeTitle = "s"), this.countdown();
    },
    /** *
     * 倒数验证码重发时间
     * */
    countdown: function () {
      let t = this.countDown,
        e = this.getVerCodeTitle;
      t >= 1
        ? ((t -= 1), (this.countDown = t), setTimeout(this.countdown, 1e3))
        : ((t = ""),
          (e = "重新获取"),
          (this.countDown = t),
          (this.getVerCodeTitle = e),
          (this.submitting = !1));
    },
    //获取当前店铺的条数
    getShopInfo() {
      getShopInfo({})
        .then((res) => {
          // console.log(res);
          this.shopPeple = res.data.balance;
        })
        .catch(() => {});
    },
    //短信转移
    transferSmsTap() {
      if (this.shopInfo.mobile) {
        if (!this.transferParams.shopName) {
          this.$message.error("请输入转入店铺昵称");
          return false;
        }
        if (!this.transferParams.count) {
          this.$message.error("请输入转移条数");
          return false;
        }
        if (this.shopPeple == 0) {
          this.$message.error("短信余额为0条，不能转移");
          return;
        }
        querySellerSetting({}).then((res) => {
          if (res.code == 1) {
            this.exchangePhone = res.data.tbPhoneBindingVO.bindingPhone;
          }
        });
        this.transferVerifyIdentityParams.shopName = this.transferParams.shopName;
        this.transferVerifyIdentityParams.moveSmsCount = this.transferParams.count;
        verifyIdentityShore(this.transferVerifyIdentityParams)
          .then((res) => {
            if (res.data == 1) {
              this.exchangeMsg = true;
              return;
            }
            this.$confirm(
              `确定转${this.transferParams.count}条短信到【${this.transferParams.shopName}】吗？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                iconClass: "iconfont iconicon-jinggao1",
              }
            )
              .then(() => {
                this.transferSMS();
              })
              .catch(() => {
                this.$message.info(res.message);
              });
          })
          .catch(() => {});
      }
    },
    //转移短信
    transferSMS() {
      const params = {
        moveSmsCount: this.transferParams.count,
        shopName: this.transferParams.shopName,
        type: 0,
        vcode: this.transferVerifyIdentityParams.inputCode,
        mobile: this.exchangePhone,
      };
      trans(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("转移短信成功");
          this.exchangeMsg = false;
        }
        this.smsPage();
      });
    },
    /** *
     * 获取店铺信息
     * */
    getSoftwareInfo() {
      getSellerInfo({}).then((res) => {
        this.shopInfo = res.data;
      });
    },
    //查询短信转移列表
    smsPage() {
      smsPage(this.smsParams)
        .then((res) => {
          this.smsTableNum = res.data.records;
        })
        .catch(() => {});
    },
    //剩余短信量发生变化事件
    surplusMessageChange(value) {
      // console.log(value,this.shopInfo.noteBalance);
      // if(Number(value)>Number(this.shopInfo.noteBalance)){
      //   this.transferParams.count = this.shopInfo.noteBalance;
      //   // debugger
      // }
    },
    //短信充值记录（官方）
    officialRecords() {
      officialRecords(this.officalParams)
        .then((res) => {
          this.officalTable = res.data.records;
        })
        .catch(() => {});
    },
    handleSizeChangeOne(val) {
      this.officalParams.size = val;
      this.officialRecords();
    },
    handleCurrentChangeOne(val) {
      this.officalParams.current = val;
      this.officialRecords();
    },
    //qq交谈
    qqTan() {
      window.open(
        "https://wpa.qq.com/msgrd?v=3&uin=800152084&site=qq&menu=yes",
        "_blank"
      );
    },
    //订购
    software() {
      // window.open("https://fw.jd.com/main/detail/FW_GOODS-1026601", "_blank");
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    //扫码转账充值
    toScanCode() {
      this.scanCodeDialogVisible = true;
    },
    handleCurrentChange(val) {
      this.recordParams.current = val;
      this.queryPayRecord();
    },
    handleSizeChange(val) {
      this.recordParams.size = val;
      this.queryPayRecord();
    },
    preventinput(event) {
      event.target.value = event.target.value.replace(/[\u4e00-\u9fa5]/g, "");
    },
    //充值金额和数量发生变化事件
    rechargeMessageNumChange(value) {
      if (value && value.length > 0) {
        var first = value.substr(0,1)
        if (first == '0') {
          this.rechargeMessageNum = value.substr(1)
          return;
        }
      }

      if (value === "") {
        this.rechargeMoney = '';
      }
      if (value >= 100 && value <= 4999) {
        //短信条数算金额
        this.rechargeMoney = (0.068 * value).toFixed(2);
      }
      if (value >= 5000 && value <= 99999) {
        this.rechargeMoney = (0.065 * value).toFixed(2);
      }
      if (value >= 100000 && value <= 499999) {
        this.rechargeMoney = (0.058 * value).toFixed(2);
      }
      if (value >= 500000 && value <= 999999) {
        this.rechargeMoney = (0.052 * value).toFixed(2);
      }
      // if (value >= 50000 && value <= 99999) {
      //   this.rechargeMoney = (0.055 * value).toFixed(2);
      // }
      // if (value >= 100000 && value <= 199999) {
      //   this.rechargeMoney = (0.052 * value).toFixed(2);
      // }
      // if (value >= 200000 && value <= 499999) {
      //   this.rechargeMoney = (0.051 * value).toFixed(2);
      // }
      // if (value >= 500000 && value <= 999999) {
      //   this.rechargeMoney = (0.05 * value).toFixed(2);
      // }
      if (value >= 1000000) {
        this.rechargeMoney = (0.05 * value).toFixed(2);
      }
    },
    rechargeMessageRemind(value) {
      let _that = this;
      if (value < 100 || value % 1 != 0) {
        _that.$message({
          message: "短信条数为大于100的整数",
        });
        _that.rechargeMoney = 0;
        return;
      }
      if (value > 10000000000) {
        _that.$message({
          message: "暂不支持该金额，如需充值请联系客服",
        });
        _that.rechargeMessageNum = 1000000000;
        return;
      }
      _that.rechargeMessageNumChange(_that.rechargeMessageNum);
    },
    rechargeMoneyChange(value) {
      // console.log(value);
      if (value && value.length > 0) {
        var first = value.substr(0,1)
        if (first == '0') {
          this.rechargeMoney = value.substr(1)
          return;
        }
      }

      if (value === "") {
        this.rechargeMessageNum = "";
      }
      this.rechargeMessageNum = 0;
      if (value >= 50000) {
        this.rechargeMessageNum = Math.floor((value * 100) / 5.0);
      } else if (value >= 26000 && value < 50000) {
        this.rechargeMessageNum = Math.floor((value * 100) / 5.2);
      } else if (value >= 5800 && value < 26000) {
        this.rechargeMessageNum = Math.floor((value * 100) / 5.8);
      } else if (value >= 325 && value < 5800) {
        this.rechargeMessageNum = Math.floor((value * 100) / 6.5);
      } else if (value >= 6.8 && value < 325) {
        this.rechargeMessageNum = Math.floor((value * 100) / 6.8);
      }


      // else if (value >= 2750 && value < 5200) {
      //   this.rechargeMessageNum = Math.floor((value * 100) / 5.5);
      // } else if (value >= 1425 && value < 2750) {
      //   this.rechargeMessageNum = Math.floor((value * 100) / 5.7);
      // } else if (value >= 696 && value < 1425) {
      //   this.rechargeMessageNum = Math.floor((value * 100) / 5.8);
      // } else if (value >= 300 && value < 696) {
      //   this.rechargeMessageNum = Math.floor((value * 100) / 6.0);
      // } else if (value >= 100 && value < 300) {
      //   this.rechargeMessageNum = Math.floor((value * 100) / 6.8);
      // }
    },
    rechargeMoneyRemind(value) {
      console.log(value);
      if (value < 6.8 || (value * 100) % 1 != 0) {
        this.$message({
          message: "金额不能少于6.8元，最多两位小数",
        });
        this.rechargeMessageNum = 0;
        return;
      }
      if (value > 1000000000) {
        this.$message({
          message: "暂不支持该金额，如需充值请联系客服",
        });
        this.rechargeMessageNum = 0;
        this.rechargeMoney = 1000000000;
        return;
      }
      this.rechargeMoneyChange(this.rechargeMoney);
    },
    //立即充值按钮跳转事件
    ImmediateRecharge() {
      if (!this.rechargeMessageNum) {
        this.$message({
          message: "请输入充值短信条数",
          type: "warning",
        });
        return;
      }
      if (!this.rechargeMoney) {
        this.$message({
          message: "请输入充值金额",
          type: "warning",
        });
        return;
      }
      if (this.rechargeMessageNum < 100 || this.rechargeMessageNum % 1 != 0) {
        this.$message({
          type: "error",
          message: "短信条数为大于100的整数",
        });
        return;
      }

      alipayPay({
        count: "1",
        paySmsTotal: this.rechargeMessageNum,
        price: this.rechargeMoney,
        type: "zdysms",
        money: this.rechargeMoney,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.error(res.message);
          return;
        } else {
          document.querySelector("body").innerHTML = res;
          const div = document.createElement("div"); // 创建div
          div.innerHTML = res; // 将返回的form 放入div
          document.body.appendChild(div);
          document.forms[0].submit();
        }
        // document.querySelector("body").innerHTML = res;
        // const div = document.createElement("div"); // 创建div
        // div.innerHTML = res; // 将返回的form 放入div
        // document.body.appendChild(div);
        // document.forms[0].submit();
      });
    },
    chargeSuccess() {
      this.chargeInfoVisible = false;
    },
    //获取充值包
    getQueryPriceConfig() {
      let that = this;
      queryPriceConfig({ type: 0 }).then((res) => {
        //数组里边对象某个参数的排序
        function compare(protoTypeName) {
          return function (object1, object2) {
            var val1 = object1[protoTypeName];
            var val2 = object2[protoTypeName];
            if (val1 < val2) {
              return -1;
            } else if (val1 > val2) {
              return 1;
            } else {
              return 0;
            }
          };
        }

        that.blockData = res.data.sort(compare("rechargeType"));
        console.log(this.blockData);
      });
    },
    //获取充值记录
    queryPayRecord() {
      queryPayRecord(this.recordParams)
        .then((res) => {
          this.recordData = res.data.records;
          this.recordTotal = Number(res.data.total);
        })
        .catch((e) => {});
    },
    paginationFunction(event) {
      this.recordParams.current = event.current;
      this.recordParams.size = event.pageSize;
      this.queryPayRecord();
    },
    //切换事件
    hugItemBtn(type) {
      this.topSelect = type;
      if (type === 1) {
        this.showcode = false;
      }
      if (type === 2) {
              let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.recordParams.startTime = this.getDateStr(-30) + " 00:00:00";
      this.recordParams.endTime = `${yy}-${mm}-${dd} 23:59:59`;
      this.queryPayRecord();
      }
    },
    //立即充值弹窗
    rechargeTap(index) {
      let that = this;
      that.rechargeCount = 1;
      const [rechargeData, rechargeNum] = [
        that.blockData[index],
        that.rechargeCount,
      ];
      that.checkedPackage[0].amount = rechargeData.amount;
      that.checkedPackage[0].price = rechargeData.price;
      that.checkedPackage[0].originalMoney = rechargeData.originalMoney;
      that.checkedPackage[0].concessionalRate = rechargeData.money; //优惠价
      that.checkedPackage[0].payType = rechargeData.payType; //支付方式
      that.checkedPackage[0].money = rechargeData.money;
      that.checkedPackage[0].priceProject = rechargeData.priceProject;
      that.checkedPackage[0].totalMoney = (
        rechargeData.money * that.rechargeCount
      ).toFixed(2);
      that.rechargeData = rechargeData;
      if (this.rechargeData.payType.length > 0) {
         let payType = this.rechargeData.payType.split(",");
          if (payType.indexOf('3') != '-1') {
            this.isShowPrePay = true;
            this.rechargeManner = 3;
          } else {
            this.isShowPrePay = false;
          }

          if (payType.indexOf('0') != '-1') {
            this.isShowAliPay = true;
            this.rechargeManner = 0;
          } else {
            this.isShowAliPay = false;
          }
         
      }
      // console.log(payType);
      // if (payType.length == 2&&payType[0]==0&&payType[1]==1) {
      //   this.thisPayType = 0;
      //   this.rechargeManner = 0;
      //   // console.log(33333);
      // }else if(payType.length == 2){
      //   payType.forEach((low)=>{
      //     if (low == 0) {
      //       this.thisPayType = 1;
      //       this.rechargeManner = 0;
      //       // console.log(11111);
      //     } else if (low == 1) {
      //       this.thisPayType = 2;
      //       this.rechargeManner = 2;
      //       // console.log(22222);
      //     } 
      //   })
      // } else if(payType.length == 1){
      //   payType.forEach((low) => {
      //     if (low == 0) {
      //       this.thisPayType = 1;
      //       this.rechargeManner = 0;
      //       // console.log(11111);
      //     } else if (low == 1) {
      //       this.thisPayType = 2;
      //       this.rechargeManner = 2;
      //       // console.log(22222);
      //     } 
      //   });
      // }else if(payType.length == 3){
      //   this.thisPayType = 0;
      //   this.rechargeManner = 0;
      // }

      that.dialogVisible = true;
      // console.log(this.rechargeData.priceProject);
    },
    //弹窗套餐数量事件
    handleChange(value) {
      this.checkedPackage[0].totalMoney = (
        this.checkedPackage[0].money * value
      ).toFixed(2);
    },
    //套餐充值选择支付方式事件
    ChangePayTypeCheck(type) {
      this.payTypeCheck = type;
      if (this.payTypeCheck == 1) {
        this.showcode = false;
      }
    },
    //支付宝支付请求
    alipayPay() {
      // console.log(this.rechargeManner);
      // return;
      if (this.rechargeManner == 0) {
        alipayPay({
          //充值包ID
          rechargePacketId: this.rechargeData.id,
          type: "sms",
          count: this.rechargeCount.toString(),
          paySmsTotal: this.checkedPackage[0].amount,
          price: this.checkedPackage[0].price,
          money: this.blockDatamoney,
          priceProject: this.rechargeData.priceProject,
        })
          .then((res) => {
            // console.log(res);
            // return;
            // document.querySelector("body").innerHTML = res;
            //   const div = document.createElement("div"); // 创建div
            //   div.innerHTML = res; // 将返回的form 放入div
            //   document.body.appendChild(div);
            //   document.forms[0].submit();
            console.log(res.code);
            if (res.code == 0) {
              this.$message.error(res.message);
              return;
            } else {
              document.querySelector("body").innerHTML = res;
              const div = document.createElement("div"); // 创建div
              div.innerHTML = res; // 将返回的form 放入div
              document.body.appendChild(div);
              document.forms[0].submit();
            }
            // debugger;
          })
          .catch((res) => {
            console.log(111111);
          });
      } else if (this.rechargeManner == 1) {
        wenXinPay({
          //充值包ID
          rechargePacketId: this.rechargeData.id,
          type: "sms",
          count: this.rechargeCount.toString(),
          paySmsTotal: this.checkedPackage[0].amount,
          price: this.checkedPackage[0].price,
          money: this.blockDatamoney,
          priceProject: this.rechargeData.priceProject,
        })
          .then((res) => {
            if (res.code == 0) {
              this.$message.error(res.message);
            } else {
              this.wxData = res.data;
              this.wxData.image = this.wxData.image;
              this.weixinDialogVisible1 = true;
              this.closeStatueVerify1();
            }
          })
          .catch((e) => {});
      } else if (this.rechargeManner == 2) {
        window.location.href =
          "https://fw.jd.com/main/detail/FW_GOODS-118401?rdct=true";
        window.open();
      } else if (this.rechargeManner == 3) {
         this.payLoading = true;
         prePay({
          //充值包ID
          rechargePacketId: this.rechargeData.id,
          type: "sms",
          count: this.rechargeCount.toString(),
          paySmsTotal: this.checkedPackage[0].amount,
          price: this.checkedPackage[0].price,
          money: this.blockDatamoney,
          priceProject: this.rechargeData.priceProject,
        })
          .then((res) => {
             this.payLoading = false;
            if (res.code == 0) {
              this.$message.error(res.message);
              return;
            } else {
              window.location = res.data.chnlUrl;
            }
            // debugger;
          })
          .catch((res) => {
            console.log(111111);
          });
      }
    },
    handleClose() {
      this.weixinDialogVisible1 = false;
    },
    handleClose1() {
      this.stateofpayment == "FAIL";
      this.dialogVisible = false;
      this.weixinDialogVisible1 = false;
    },
    //验证是否可以关闭微信二维码窗口
    closeStatueVerify1() {
      if (this.weixinDialogVisible1 == true && this.stateofpayment == "FAIL") {
        closeStatueVerify({ outTradeNo: this.wxData.outTradeNo })
          .then((res) => {
            this.stateofpayment = res.data;
          })
          .catch((e) => {});
        // }
        const that = this;
        // 使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
        setTimeout(function () {
          that.closeStatueVerify1();
        }, 2000);
      } else if (
        this.weixinDialogVisible1 == true &&
        this.stateofpayment == "SUCCESS"
      ) {
        this.$message.success("支付成功");
        this.dialogVisible = false;
        this.weixinDialogVisible1 = false;
        this.stateofpayment == "FAIL";
      }
    },

    //弹窗去支付事件
    goGoPay(money) {
      this.blockDatamoney = money;
      this.alipayPay();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .bottom_text {
  width: 238px;
  margin: 0 auto;
}
/deep/ .code_title {
  margin: 0 auto;
  text-align: center;
  width: 108px;
  height: 25px;
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  color: rgba(88, 130, 251, 1);
  opacity: 1;
}
/deep/.el-dialog__body {
  // width: 630px;
  // height: 400px;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 6px;
  padding: 30px 25px 30px 27px;
}
/deep/.el-dialog__title {
  width: 64px !important;
  height: 22px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  line-height: 28px !important;
  color: rgba(51, 51, 51, 1) !important;
  opacity: 1 !important;
}
/deep/.el-dialog {
  border-radius: 6px !important;
}
/deep/ .el-dialog .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid rgba(243, 243, 243, 1);
  opacity: 1;
  height: 54px;
  line-height: 54px;
  border-radius: 6px;
}
/deep/ .el-pagination {
  padding: 0px;
}
/deep/ .el-alert {
  padding-top: 15px !important;
  padding-bottom: 20px !important;
}
/deep/ .el-input--medium .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/ .el-table .el-table__header-wrapper th .cell {
  height: 60px;
  line-height: 50px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  background-color: #fafafa;
  color: #333333;
}

.el-radio__inner {
  border: none;
  width: 0;
}
.el-radio__inner {
  display: none;
}
.footerClass {
  padding: 14px 12px;
  height: 86px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: 400;
  line-height: 21px;
  position: relative;
  .icon_i {
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background-color: #fe8f8a;
    color: #fff;
    font-size: 10px;
    text-align: center;
    line-height: 14px;
    font-weight: bold;
    top: 18px;
    left: 16px;
  }
  .qqSay {
    position: relative;
    width: 50px;
    height: 16px;
    background: linear-gradient(89deg, #356aff 100%, #0840de 100%);
    opacity: 1;
    border-radius: 2px;
    padding: 1px 7px;
    color: #fff;
    font-size: 14px;
    margin-left: 5px;
    margin-right: 12px;
    bottom: 2px;
    cursor: pointer;
    &:hover{
      bottom: 4px;
      box-shadow: 3px 3px 15px #ddd;
    }
  }
  .orderAndUse {
    position: relative;
    width: 50px;
    height: 16px;
    background: #fe4d45;
    opacity: 1;
    padding: 1px 5px;
    color: #fff;
    font-size: 14px;
    margin-left: 2px;
    border-radius: 2px;
    bottom: 2px;
    cursor: pointer;
     &:hover{
      bottom: 4px;
      box-shadow: 3px 3px 15px #ddd;
    }
  }
}
.titileDefinition {
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}
.section-right-content-box {
  min-width: 1080px;
  .top-box {
    margin: 11px 20px;
  }

  .tab-line {
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;
    .tab-item {
      text-align: center;
      width: 130px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
  .box-shadow {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background: #fff;
  }
  .hug {
    overflow: hidden;
    margin-bottom: 30px;
    cursor: pointer;
    .underlined {
      height: 2px;
      width: 40px;
      margin-left: 7px;
      margin-top: 14px;
      opacity: 1;
      cursor: pointer;
    }
  }
  .orderBottom {
    position: relative;
    width: 160px;
    height: 40px;
    line-height: 40px;
    // background-color: #fe4d45;
    color: #fff;
    left: 74px;
    border-radius: 3px 0px 0px 3px;
    .sumPayable {
      position: absolute;
      right: 0;
      top: 0px;
      width: 200px;
      float: right;
      background-color: #2062e7;
      color: white;
      line-height: 40px;
      text-align: center;
      border-radius: 3px;
      // background-image: url("../../assets/images/coner1.png")
    }
    .redPacketReduction {
      position: absolute;
      width: 343px;
      height: 40px;
      background-color: #fafafa;
      border-radius: 0px 3px 3px 0px;
      margin: 20px;
      top: -34px;
      left: -61px;
      .duosaho {
        position: absolute;
        left: 20px;
        color: #333333;
        z-index: 99999px;
      }
    }
  }
  .goPayButton {
    // float: right;
    text-align: right;
    margin-top: 20px;
  }
  .textCenter {
    text-align: center;
  }
  .weixerweima {
    display: flex;
    justify-content: center;
  }
  .recharge-box {
    padding: 20px 28px 30px 28px;
    .alert_box {
      padding: 0 28px 20px 28px;
      background: #f7f8fe;
      opacity: 1;
      font-weight: 400;
      position: relative;

      .alert {
        opacity: 1;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        line-height: 21px;
        padding: 11px 0 0 7px;
      }
      .icon_i {
        display: inline-block;
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: #7f85e9;
        color: #fff;
        font-size: 10px;
        text-align: center;
        line-height: 14px;
        font-weight: bold;
        top: 15px;
        left: 15px;
      }
    }
    .form-box {
      text-align: left;
      .item {
        display: inline-block;
        vertical-align: middle;
        .item-name {
          font-size: 14px;
          // font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
          color: #333333;
          opacity: 1;
        }
      }
    }
    .itemBottom {
      margin-left: 8px;
      width: 98px;
      height: 32px;
      color: #ffffff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
        border: 1px solid #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      margin: 20px 0 0 0;
      margin-bottom: 20px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
      .question_iconText {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .question_icon {
        width: 14px;
        height: 14px;
        // color: #cccccc;
        display: inline-block;
        line-height: 12px;
        text-align: center;
        border-radius: 14px;
        border: 1px solid #7f85e9;
        font-size: 10px;
        font-weight: normal;
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
        }
      }
    }
    .containCharge {
      padding-top: 30px;
      position: relative;
      .imgRelative {
        display: inline-block;
        width: 102px;
        height: 71px;
        position: absolute;
        z-index: 2;
        right: -2px;
        top: -24px;
      }
      .buttonRelative {
        position: absolute;
        left: 82px;
        bottom: 13px;
        text-align: center;
        .buttonStyle {
          width: 140px;
          height: 32px;
          background: #ffffff;
          color: #fe4d45;
          opacity: 1;
          border-radius: 22px;
          &:hover {
            background: #fe4d45;
            color: #fff;
          }
        }
        .buttonStyleOne {
          width: 140px;
          height: 32px;
          background: linear-gradient(123deg, #ffebcc 0%, #f7d59a 100%);
          opacity: 1;
          border-radius: 22px;
          border-color: none;
          color: rgba(81, 47, 24, 1);
        }
        .buttonStyleTwo {
          width: 140px;
          height: 32px;
          background: #ffffff;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          opacity: 1;
          border-radius: 22px;
          &:hover {
            background: #fe4d45;
            color: #fff;
          }
        }
        .buttonStyleThere {
          width: 140px;
          height: 32px;
          background: #fe4d45;
          border: 1px solid #fe4d45;
          color: #fff;
          opacity: 1;
          border-radius: 22px;
        }
      }
      .block-vip {
        background: #fff;
        opacity: 1;
        border: 1px solid #eeeeee;
        &:hover {
          border: 1px solid #fe8f8a;
        }
      }
      .block-tehui {
        background: linear-gradient(180deg, #464762 0%, #2f2e47 100%);
        opacity: 1;
      }
      .block-tuijian {
        background: #fff6f6;
        opacity: 1;
        border: 1px solid #fff6f6;
        &:hover {
          border: 1px solid #fe8f8a;
        }
      }
      .block-tuijian1 {
        background: #fff;
        border: 1px solid #eeeeee;
        &:hover {
          border: 1px solid #fe8f8a;
        }
      }
      .block-box {
        width: 100%;
        display: inline-block;
        vertical-align: top;
        width: 308px;
        height: 180px;
        border-radius: 12px;
        padding: 15px 5px 5px 5px;
        margin-top: 30px;
        margin-bottom: 20px;
        margin-right: 19px;
        position: relative;
        bottom: 0px;
        transition: bottom 0.3s;
        .labelCopy {
          position: absolute;
          right: -4px;
          top: -6px;
          width: 96px;
          height: 34px;
          background: rgba(254, 77, 69, 1);
          opacity: 1;
          border-radius: 12px 18px 18px 0px;
          text-align: center;
          line-height: 34px;
          color: rgba(255, 255, 255, 1);
          font-size: 14px;
          font-weight: 500;
        }
        .labelCopy1 {
          position: absolute;
          right: 9px;
          top: -41px;
          width: 290px;
          height: 41px;
          background: rgba(254, 77, 69, 1);
          opacity: 1;
          border-radius: 6px 6px 0px 0px;
          text-align: center;
          line-height: 34px;
          color: rgba(255, 255, 255, 1);
          font-size: 14px;
          font-weight: 500;
          .labelCopy1_title1 {
            float: left;
            font-size: 16px;
            font-weight: normal;
          }
          .labelCopy1_title2 {
            font-size: 12px;
            padding-top: 6px;
            float: left;
            // font-family: PingFang SC;
            font-weight: 500;
          }
          .labelCopy1_time {
            width: 22px;
            height: 18px;
            float: left;
            border-radius: 4px;
            margin-top: 13px;
            padding: 1px 2px 0 0;
            font-size: 13px;
            background-color: #000000;
            font-weight: bold;
            line-height: 16px;
            color: #ffffff;
            opacity: 1;
          }
        }
        .block {
          padding: 11px 7px -1px 11px;
          float: left;
          width: 280px;
          background: transparent;
          -webkit-border-radius: 6px;
          -moz-border-radius: 6px;
          border-radius: 6px;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          position: relative;
          z-index: 0;
          cursor: pointer;
          .line-one {
            .big-text {
              width: 66px;
              height: 31px;
              font-size: 26px;
              font-family: SF Pro Display;
              font-weight: 500;
              line-height: 31px;
              opacity: 1;
              margin-right: 4px;
              margin-left: 5px;
            }
            .big-text1 {
              color: #333;
            }
            .big-text2 {
              color: rgba(241, 213, 170, 1);
            }
            .small-text {
              width: 42px;
              height: 20px;
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
              opacity: 1;
            }
            .small-text1 {
              color: #333333;
            }
            .small-text2 {
              color: #999999;
            }
            .small-text3 {
              color: #333;
            }
          }
          .lineHeight {
            margin-left: 9px;
            margin-top: 15px;
            width: 277px;
            height: 0px;
            border-top: 2px dashed rgba(254, 143, 138, 1);
            opacity: 0.3;
            margin-bottom: 11px;
          }
          .lineHeight-1 {
            border-top: 2px dashed #ffdddc;
            opacity: 1;
          }
          .lineHeight-3 {
            border-top: 2px dashed #ffdddc;
            opacity: 0.3;
          }
          .lineHeight-2 {
            border-top: 2px dashed rgba(255, 255, 255, 1);
          }
          .line-two {
            font-size: 16px;
            line-height: 22px;
            opacity: 1;
            font-weight: 500;
            display: inline-block;
            margin-left: 5px;
            .line-two-0 {
              color: rgba(254, 77, 69, 1);
            }
            .line-two-1 {
              color: #fe4d45;
            }
            .line-two-2 {
              color: rgba(241, 213, 170, 1);
            }
            .line-two1 {
              font-size: 14px !important;
              margin-left: 4px;
              font-weight: 400;
              opacity: 1;
            }
            .line-two1-1 {
              color: rgba(51, 51, 51, 1);
            }
            .line-two1-2 {
              color: rgba(168, 168, 178, 1);
            }
          }
          .line-three {
            margin-top: 3px;
            overflow: hidden;
            font-size: 14px;
            // width: 100%;
            box-sizing: border-box;
            display: inline-block;
            .danPrice {
              font-size: 14px;
              opacity: 1;
              font-weight: 400;
            }
            .danPrice-1 {
              color: rgba(51, 51, 51, 1);
              // margin-left: 5px;
            }
            .danPrice-2 {
              color: rgba(168, 168, 178, 1);
            }
            .danPrice1 {
              font-size: 16px;
              opacity: 1;
              font-weight: 500;
              margin-right: 2px;
              opacity: 1;
            }
            .danPrice1-0 {
              color: #fe4d45 !important;
            }
            .danPrice1-1 {
              color: #fe4d45 !important;
            }
            .danPrice1-2 {
              color: #f1d5aa !important;
            }
            .float-left {
              float: right;
            }
            .float-right {
              float: right;
              font-size: 14px;
            }
          }
          .originalPrice {
            width: 200px;
            height: 17px;
            font-size: 13px;
            font-weight: 400;
            line-height: 17px;
            color: rgba(153, 153, 153, 1);
            opacity: 1;
            margin-left: 8px;
            text-decoration: line-through;
          }
          .block-button {
            width: 111px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 16px;
            border-radius: 80px;
            margin: 17px auto 0 auto;
            cursor: pointer;
          }

          .cover {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 262px;
            height: 222px;
            -webkit-border-radius: 6px;
            -moz-border-radius: 6px;
            border-radius: 6px;
            opacity: 0.1;
          }
        }
      }
      .block-box:hover {
        box-shadow: 3px 3px 15px #eee;
        bottom: 10px;
      }
      .chargeArea {
        width: 25%;
        display: inline-block;
        vertical-align: top;
        border: 1px solid #d1d2d9;
        padding: 20px 10px 40px;
        border-radius: 6px;
        .paystyle {
          width: 100%;
          font-size: 24px;
          padding: 5px 0 5px 20px;
          margin: 0 0px 20px;
        }
        .tittle {
          // color:#999;
          font-size: 16px;
          padding: 4px 0;
        }
        .val {
          font-size: 20px;
          padding: 4px 0;
        }
        .amount {
          padding: 5px 0;
          margin: 10px 0 0;
          span {
            display: inline-block;
            height: 32px;
            line-height: 30px;
            font-size: 16px;
            padding-right: 10px;
          }
        }
        .price {
          padding: 5px 0;
          margin: 10px 0 0;
          .paymoney {
            display: inline-block;
            span:nth-child(1) {
              height: 32px;
              line-height: 30px;
              font-size: 16px;
              padding-right: 10px;
            }
            span:nth-child(2) {
              color: red;
              font-size: 24px;
            }
          }
          .originprice {
            display: inline-block;
            margin-left: 20px;
            text-decoration: line-through;
            // color:#999;
          }
        }
        .selPay {
          span {
            display: inline-block;
            height: 32px;
            line-height: 30px;
            font-size: 16px;
            padding-right: 10px;
          }
          .payType {
            display: inline-block;
            vertical-align: middle;
            .divRadio {
              width: 112px;
              height: 40px;
              display: inline-block;
              border: 1px solid #dcdfe6;
              border-radius: 3px;
              margin-right: 30px;
              // color: #7d7f82;
              line-height: 40px;
              text-align: center;
              cursor: pointer;
              &:last-child {
                margin-right: 0;
              }
              @media screen and (max-width: 1460px) {
                margin-right: 10px;
              }
            }
            .divRadioActive {
              border-color: #2062e7;
              color: #2062e7;
              //   background-image: url("../../assets/images/trueRight.png");
              background-repeat: no-repeat;
              background-size: 15px;
              background-position: right bottom;
            }
          }
        }
        .wximage {
          width: 100%;
          height: 250px;
          text-align: center;
        }
      }
    }
    .foot-box {
      background-color: #f4f5f9;
      // color: #666;
      font-size: 14px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 10px 10px;
      display: block;
      width: 800px;
      span {
        display: block;
        padding: 3px;
      }
    }
  }
  .record-box {
    padding: 20px 28px 21px 28px;
    .search{
      // width: 98px;
      //     height: 32px;
      //     font-size: 14px;
      //     border-radius: 3px;
          color: #fe4d45;
          border: 1px solid #fe4d45 ;
          // background-color: #fff
    }
  }
  .auditSuccessful_ok {
    position: absolute;
    top: 40%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #fe4d45;
    border-radius: 50%;
    opacity: 1;
  }
  .auditSuccessful_title {
    text-align: center;
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    opacity: 1;
  }
  .exchange-box {
    text-align: left;
    color: #333333;
    padding: 20px 28px 30px 28px;
    .header-tips-box {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      background-color: #fffaee;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      padding: 10px 20px;
      text-align: left;
      display: block;
      width: 100%;
      .tips-icon {
        float: left;
        margin-top: 5px;
        margin-right: 5px;
      }
      .tips-content {
        float: left;
        .alert_box {
          padding: 0;
          background: #fffaee;
          opacity: 1;
          font-weight: 400;
          position: relative;

          .alert {
            opacity: 1;
            font-size: 14px;
            color: #333333;
            font-weight: 400;
            line-height: 21px;
            padding: 0 0 0 16px;
          }
          .icon_i {
            display: inline-block;
            position: absolute;
            width: 14px;
            height: 14px;
            border-radius: 14px;
            background-color: #ffb95e;
            color: #fff;
            font-size: 10px;
            text-align: center;
            line-height: 14px;
            font-weight: bold;
            margin: -14px 0 0 -22px;
          }
        }
        .icon_i {
          display: inline-block;
          position: absolute;
          width: 14px;
          height: 14px;
          border-radius: 14px;
          background-color: #fe8f8a;
          color: #fff;
          font-size: 10px;
          text-align: center;
          line-height: 14px;
          font-weight: bold;
          top: 18px;
          left: 16px;
        }
        span {
          display: block;
          font-size: 14px;
          color: #ff7600;
          line-height: 22px;
        }
      }
    }
    .item {
      margin-top: 15px;
      font-size: 14px;

      .alert_box {
        margin-top: 20px;
        margin-bottom: 20px;
        height: 44px;
        background: #fff6f6;
        opacity: 1;
        font-weight: 400;
        position: relative;

        .alert {
          opacity: 1;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
          line-height: 21px;
          padding: 10px 0 0 36px;
        }
        .icon_i {
          display: inline-block;
          position: absolute;
          width: 14px;
          height: 14px;
          border-radius: 14px;
          background-color: #fe8f8a;
          color: #fff;
          font-size: 10px;
          text-align: center;
          line-height: 14px;
          font-weight: bold;
          top: 32%;
          left: 14px;
        }
      }
      // color: #666;
      .num-box {
        padding: 8px 10px;
        margin-left: 20px;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border-radius: 15px;
        font-size: 14px;
        position: relative;
        .span {
          position: absolute;
          top: 0;
          left: 0;
          height: 30px;
          width: 100%;
          opacity: 0.1;
          -webkit-border-radius: 15px;
          -moz-border-radius: 15px;
          border-radius: 15px;
        }
      }
    }
    .bind-tips {
      margin: 20px 0;
      width: 272px;
      padding: 0 10px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      background: rgba(204, 204, 204, 0.1);
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      font-size: 14px;
      // color: #666;
      .mark {
        display: inline-block;
        vertical-align: middle;
        height: 10px;
        width: 10px;
        font-size: 6px;
        color: #fff;
        background-color: #999;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
  }
}
/* 充值弹窗 */
.recharge-wrapper {
  text-align: left;
  .item {
    margin-bottom: 20px;
    .recharge-box {
      cursor: pointer;
      text-align: center;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      display: inline-block;
      padding: 10px;
      vertical-align: text-top;
      border: 2px solid #1f62e7;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      width: 178px;
      height: 122px;
      .line-one {
        margin-bottom: 5px;
      }
      .line-two {
        font-size: 14px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 2px solid #eee;
        .highlight-text {
          color: #fe6000;
        }
      }
      .line-three {
        font-size: 14px;
        .highlight-text {
          color: #fe6000;
        }
      }
    }
  }
  .redpack {
    font-size: 14px;
    color: #ff1901;
    font-weight: 600;
    text-align: right;
    margin: 11px 0;
  }
  .weixinDialog {
    width: 250px;
    height: 467px;
    position: relative !important;
    right: 600px;
    border: 1px solid red;
    border-radius: 3px;
    right: -650px;
    top: 0;
  }
  .pay-price-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 12px;
    font-size: 14px;
    text-align: right;
    background-color: #f2f2f2;
  }
  .pay-box {
    .select-pay {
      overflow: hidden;
      margin-bottom: 25px;
      padding-left: 20px;
      margin-top: 25px;
      .pay-item {
        height: 26px;
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
        color: rgba(102, 102, 102, 1);
        float: left;
        margin-right: 40px;
        border-bottom: 3px solid #fff;
        cursor: pointer;
      }
    }
    .code-box {
      padding: 0 160px;
      .code-item {
        width: 160px;
        text-align: center;
        .img-box {
          width: 160px;
          height: 160px;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          padding: 18px;
          border: 1px solid #eee;
          .code-img {
            width: 100%;
            height: 100%;
          }
        }
        .img-foot-box {
          width: 160px;
          text-align: center;
          box-sizing: border-box;
          padding: 8px 0;
          .pay-img {
            display: inline-block;
            vertical-align: middle;
            margin-right: 8px;
          }
          .pay-title {
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
    .input-box {
      width: 388px;
      margin: 0 auto;
      .input-item {
        margin-bottom: 18px;
        .input-head {
          margin-bottom: 3px;
        }
      }
      .input-tips {
        color: #cccccc;
        margin-bottom: 25px;
      }
    }
  }
}
.fontBold {
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
}
/* 身份验证弹窗 */
.exchange-msg-wrapper {
  .tips-head {
    text-align: left;
    background-color: rgba(255, 118, 0, 0.1);
    color: #ff7600;
    box-sizing: border-box;
    padding: 5px 10px;
    font-size: 14px;
    .tips-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .checked-box {
    width: 300px;
    margin: 30px auto 30px auto;
    text-align: left;
    .item {
      margin-bottom: 8px;
    }
  }
}
.ImmediateRecharge {
  border-radius: 3px;
  // left: -250px;
  .ImmediateRecharge-dialog1 {
    .payType {
      display: inline-block;
      vertical-align: middle;
      .divRadio {
        width: 122px;
        height: 40px;
        display: inline-block;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .divRadioActive {
        border-color: #2062e7;
        color: #2062e7;
        // background-image: url("../../assets/images/trueRight.png");
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: right bottom;
      }
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  .tips {
    position: relative;
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: rgb(199, 25, 25);
  }
  .wrong {
    width: 115px;
    height: 40px;
    border: 1px solid rgba(220, 220, 220, 1);
    box-shadow: 0px 8px 10px rgba(32, 98, 231, 0.2);
    opacity: 1;
    border-radius: 3px;
  }
}
.tips p {
  font-size: 14px;
  padding: 2px 0;
  margin: 0 0;
  border-bottom: 1px solid #ccc;
  span {
    float: right;
  }
}
</style>
